import { render } from "./DialogMask.vue?vue&type=template&id=072e7177"
import script from "./DialogMask.vue?vue&type=script&lang=js"
export * from "./DialogMask.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__